import { combineReducers } from '@reduxjs/toolkit';

import callFavourites from './slices/callFavourites';
import chatPreferences from './slices/chatPreferences';
import chatUnread from './slices/chatUnread';
import convPrefs from './slices/convPrefs';
import notifications from './slices/notifications';
import presence from './slices/presence';
import reminders from './slices/reminders';

const rootReducer = combineReducers({
  callFavourites,
  chatPreferences,
  chatUnread,
  convPrefs,
  notifications,
  presence,
  reminders,
});

export default rootReducer;
